<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row justify-content-end">
                <div class="col-auto pt-2">
                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                </div>
                <div class="col-auto">
                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                </div>
            </div>
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody v-for="(items, i) in voucherItems" :key="i">
                            <tr class="dtrg-group dtrg-start">
                                <td colspan="4" class="text-capitalize fw-700 border-top-bottom-2">
                                    <span class="text-secondary mr-2"><i class="fas fa-ticket-alt"></i></span>{{items[0].voucherName}}
                                </td>
                            </tr>
                            <tr v-for="(item, j) in items" :key="j">
                                <td>{{j+1}}</td>
                                <td>{{item.memberDisplayName}}</td>
                                <td>{{item.mobile}}</td>
                                <td>{{item.expiryDate == 0 ? '-' : convertTimestampToDateTime(item.expiryDate)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.voucher_balance')}}
                            <small class="m-0 text-muted">"{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="isBalanceSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isBalanceSpinnerShow && voucherBalanceItems.length == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isBalanceSpinnerShow && voucherBalanceItems.length != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                                <div class="col-sm-12 overflow-auto">
                                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                                        <thead class="thead-themed">
                                            <tr>
                                                <th v-for="tblHeader in balanceFields" :key="tblHeader.key">{{tblHeader.label}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(items, i) in voucherBalanceItems" :key="i">
                                                <td>{{i + 1}}</td>
                                                <td>{{items.memberDisplayName}}</td>
                                                <td>{{formatPrice(items.amount)}}</td>
                                                <td>{{items.total}}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</td>
                                                <td class="border-top-bottom-2 fw-500">{{totalAmount}}</td>
                                                <td class="border-top-bottom-2 fw-500">{{totalBalance}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import exTbl from './../../../../assets/js/dashboard/export-table-header'
import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
export default {
    name: "voucherSummaryExpiry",
    data(){
        return{
            isSpinnerShow: false,
            voucherItems: [],
            filterObj: {},
            totalBalance: 0, totalAmount: 0,
            exportData: [], 
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
        }
    }, 
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "name", label: this.$i18n.t('table.header.name')},
                {key: "mobile", label: this.$i18n.t('table.header.contact')},
                {key: "expiryDate", label: this.$i18n.t('label.expiry_date')},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.voucher').toUpperCase()] = "voucher"
            ret[this.$i18n.t('table.header.name').toUpperCase()] = "name"
            ret[this.$i18n.t('table.header.contact').toUpperCase()] = "mobile"
            ret[this.$i18n.t('label.expiry_date').toUpperCase()] = "expiry"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            if(this.$parent.tab == 'expiry'){
                this.setExportData(this.exportData)
            }
        }
    },
    methods:{
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24)
        },
        formatPrice(price){
            return formatPrice(price)
        },
        async setVoucherSummaryExpiry(filterObj){
            this.filterObj = filterObj;
            var endDateFilter = "&startCreateDate=0&endCreateDateDate=" + moment(filterObj.dateBalance.startDate).unix()
            var dateFilter = !filterObj.dateFilter ? "" : "&startExpiryDate=" + moment(filterObj.date.startDate).unix() + "&endExpiryDate=" + moment(filterObj.date.endDate).unix()
            var searchFilter = filterObj.searchVoucher == "" ? "" : "&search=" + filterObj.searchVoucher

            this.isSpinnerShow = true;
            var result = await this.getVoucherBalance(endDateFilter + dateFilter + searchFilter);
            var retData = setReturnData(result, this.totalEntries, this.page)
            
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;

            this.voucherItems = _.groupBy(result, "voucherID")
            this.isSpinnerShow = false;

            await this.getExportData( "?expiryreport=1" + endDateFilter + dateFilter + searchFilter)
        },
        async getVoucherBalance(searchFilter){
            let $vm = this;

            let QUERY_STRING = "?expiryreport=1&page=" + this.page + searchFilter;
            const url =  this.$api.REPORT_VOUCHER + this.$api.REPORT_BALANCE + QUERY_STRING ;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result;
                $vm.totalEntries = response.data.count;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.setVoucherSummaryExpiry(this.filterObj);
                //document.getElementById('btnToTop').click(); 
            }
        },
        async getExportData(strFilter){
            let $vm = this;

            const url =  this.$api.REPORT_VOUCHER + this.$api.REPORT_BALANCE + strFilter ;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.exportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text + ")" 
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('salon_report.view') + this.$i18n.messages[this.$i18n.locale].tab.reportVoucherSummaryType[2].text,
                " "];
            var exportFileName =  header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    voucher: data[i].voucherName,
                    name: data[i].memberDisplayName,
                    mobile: data[i].mobile,
                    expiry: data[i].expiryDate == 0 ? "-" : this.convertTimestampToDateTime(data[i].expiryDate )
                })
            }

            var exportObj = {
                data: exportData,
                fields: this.exportFields,
                headers: exportHeaders,
                fileName: exportFileName
            }
            this.$emit('setExportData', exportObj)
        },
    }
}
</script>
<style scoped>
.link{
    cursor: pointer;
}
.show{
    display: block;
}
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
.modal-body{
    max-height: 80vh;
    min-height: 80vh;
    overflow-y: auto;
}
</style>